import { styled } from "@mui/material";
import Tabs from "@mui/material/Tabs";

interface StyledTabsProps {
  tabsType: "primary" | "secondary";
}

const StyledTabs = styled(Tabs, {
  shouldForwardProp: (prop) => prop !== "tabsType",
})<StyledTabsProps>`
  display: inline-flex;
  border-bottom: 1px solid ${(props) => props.theme.wsc.palette.neutral[500]};

  .MuiTabs-indicator {
    height: ${(props) => (props.tabsType === "primary" ? "4px" : "2px")};
    border-radius: ${(props) => props.theme.wsc.radius.m};
    background-color: ${(props) =>
      props.tabsType === "primary"
        ? props.theme.wsc.palette.primary[300]
        : props.theme.wsc.palette.neutral[100]};
  }
`;

export default StyledTabs;
